module.exports = __webpack_public_path__ + "img/Pelletsproduktion.d6b5ad2.webp";